import React from'react';
import {observer} from 'mobx-react-lite'
import ManagerMenu from './ManagerMenu'
import ParentMenu from './ParentMenu'
import TrainerMenu from './TrainerMenu'
import MemberMenu from './MemberMenu'
import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";

const ClubMenu = () => {
    if (clubStore.club.roles.length === 0) return null
    return (
        <li className="nav-item dropdown position-static py-lg-2 me-lg-n1 me-xl-0">
            <a className="nav-link dropdown-toggle active" aria-current="page" href="#" role="button"
               data-bs-toggle="dropdown" data-bs-trigger="hover" aria-expanded="false">{clubStore.club.name}</a>
            <div className="dropdown-menu rounded-4 p-4" style={{"--cz-dropdown-spacer": ".875rem"}}>
                <div className="d-flex flex-column flex-lg-row gap-4">
                    <ManagerMenu/>
                    {/*<ParentMenu/>*/}
                    {/*<TrainerMenu/>*/}
                    {/*<MemberMenu/>*/}
                </div>
            </div>
        </li>
    )
}

export default observer(ClubMenu);